module.exports = __webpack_public_path__ + "static/key-trailmakers-fd79d0c8d9ec984da99fe98d43191b9b.webp";